import React, { Component } from 'react'

interface IProps {
    // er
    ror?: string,
    value: string
    field: string
    key: string
    // isDisabled: boolean,
    // info?: string,
    // parsed?: string | number,
}
export default function CellSettings({ value, key, field }: IProps): JSX.Element {
    const getValue = (): string => {
        if (field == '__uid') return `${value.substring(0, 5)}...`

        return value
    }

    return (
        <td key={key}>
            <span title={"xpto"}>{getValue()}</span>
        </td>
    )
}
